import { Dictionary } from "sbtech-sports-data-api-client";
import { Selection, OddStyles } from "../../data";
export class SelectionSortFuncs {

    static outcomeTypeOrder = ["Home", "Tie", "Away", "Over", "Under"];
    static secondLineOutcomeType = ["Away", "Under"];

    /* istanbul ignore next */
    private static SortByOutcomeType = (sel1: Selection, sel2: Selection) => {
        if (SelectionSortFuncs.outcomeTypeOrder.indexOf(sel1.outcomeType) === -1) {
            return 1;
        }
        let sel1OrderIndex: number = SelectionSortFuncs.outcomeTypeOrder.indexOf(sel1.outcomeType);
        let sel2OrderIndex: number = SelectionSortFuncs.outcomeTypeOrder.indexOf(sel2.outcomeType);
        return sel1OrderIndex - sel2OrderIndex;
    }

    /* istanbul ignore next */
    private static SortByOutcomeTypeAndPointsHC = (sel1: Selection, sel2: Selection) => {
        if (SelectionSortFuncs.outcomeTypeOrder.indexOf(sel1.outcomeType) === -1) {
            return 1;
        }
        /* istanbul ignore next */
        let sel1OrderIndex: number = SelectionSortFuncs.secondLineOutcomeType.indexOf(sel1.outcomeType) !== -1
            ? -sel1.points
            : sel1.points;
        /* istanbul ignore next */
        let sel2OrderIndex: number = SelectionSortFuncs.secondLineOutcomeType.indexOf(sel2.outcomeType) !== -1
            ? -sel2.points
            : sel2.points;

        /* istanbul ignore next */
        if (sel1OrderIndex > sel2OrderIndex) {
            return 1;
        }

        /* istanbul ignore next */
        if (sel1OrderIndex < sel2OrderIndex) {
            return -1;
        }

        return SelectionSortFuncs.SortByOutcomeType(sel1, sel2);
    }

    /* istanbul ignore next */
    private static SortByOutcomeTypeAndPointsOU = (sel1: Selection, sel2: Selection) => {
        if (SelectionSortFuncs.outcomeTypeOrder.indexOf(sel1.outcomeType) === -1) {
            return 1;
        }

        /* istanbul ignore next */
        if (sel1.points > sel2.points) {
            return 1;
        }

        /* istanbul ignore next */
        if (sel1.points < sel2.points) {
            return -1;
        }

        return SelectionSortFuncs.SortByOutcomeType(sel1, sel2);
    }

    private static SortByOdd = (sel1: Selection, sel2: Selection): number => {
        let odd1: number = parseFloat(sel1.displayOdds[OddStyles.decimal]);
        let odd2: number = parseFloat(sel2.displayOdds[OddStyles.decimal]);
        if (odd1 < odd2) { return -1; }
        if (odd1 > odd2) { return 1; }
        return 0;
    }

    static Funcs: Dictionary<(a: Selection, b: Selection) => number> = {
        ML: SelectionSortFuncs.SortByOutcomeType,
        HC: SelectionSortFuncs.SortByOutcomeTypeAndPointsHC,
        OU: SelectionSortFuncs.SortByOutcomeTypeAndPointsOU,
        QA: SelectionSortFuncs.SortByOdd
    };

    public static Sort(marketTypeId: string): (a: Selection, b: Selection) => number {
        return SelectionSortFuncs.Funcs[marketTypeId];
    }

}